import React from "react";

const DataDeletion = () => {
  const isUCAT =
    window.location.hostname.split(".")[0]?.includes("ucat") ||
    window.location.hostname.split(".")[0] === "192";
  return (
    <div style={{ margin: "20px" }}>
      <h1 style={{ fontSize: "20px" }}>
        Data Deletion Instructions for Everest Tutoring
      </h1>
      <h2 style={{ fontSize: "20px" }}> Request Deletion from Our System</h2>
      <p style={{ fontSize: "20px" }}>
        To delete your account data stored in our website, email us at:{" "}
        <a
          href="mailto:info@everesttutoring.com.au"
          style={{ fontSize: "20px" }}
        >
          info@everesttutoring.com.au
        </a>
      </p>
      <p style={{ fontSize: "20px" }}>
        Include your Facebook User ID or the email used to log in. We will
        delete all associated data from Firebase Authentication and databases
        within 7 business days.
      </p>
      <p style={{ fontSize: "20px" }}>
        {" "}
        <strong style={{ fontSize: "20px" }}>Website</strong> refers to Everest
        Tutoring's {isUCAT ? "UCAT" : "GATE"} AI Online Question Bank,
        accessible from{" "}
        <a
          href={
            isUCAT
              ? "https://ucat.everesttutoring.com.au"
              : "https://learn.everesttutoring.com.au"
          }
          style={{ fontSize: "20px" }}
        >
          {isUCAT
            ? "ucat.everesttutoring.com.au"
            : "learn.everesttutoring.com.au"}
        </a>
      </p>
    </div>
  );
};

export default DataDeletion;
